import { defaultFilter as defaultScreensFilter } from '@atlassian/jira-admin-screens-services/src/services/screens-service/actions/index.tsx';
import type {
	ScreensFilter,
	ScreensOrderBy,
} from '@atlassian/jira-admin-screens-services/src/services/screens-service/types.tsx';
import { number } from '@atlassian/jira-common-url-transform-presets';

export const toUrlTransformer = (filter?: ScreensFilter) => {
	const { pageNumber, searchFilter, orderBy } = filter || {};
	return { pageNumber, searchFilter, orderBy };
};

export const fromUrlTransformer = (params: { [key: string]: string }): ScreensFilter => {
	const { pageNumber, searchFilter, orderBy } = params;
	const parsedNumber = Number.isNaN(number.parse(pageNumber))
		? defaultScreensFilter.pageNumber
		: number.parse(pageNumber);
	const parsedOrderBy: ScreensOrderBy | undefined =
		orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
	return {
		...defaultScreensFilter,
		pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
		searchFilter,
		orderBy: parsedOrderBy,
	};
};
